import React from "react";
import LoadingIndicator from "./LoadingIndicator";
import { Translations } from "../translations";

const LoadingDocument = () => (
  <LoadingIndicator message={Translations.modal.messages.pdf_loading} />
);

export default LoadingDocument;
